import { render, staticRenderFns } from "./ExternalCollectionPage.vue?vue&type=template&id=34c6180a&"
import script from "./ExternalCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports